
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"opacity":".7","x":".5","y":".5","width":"29","height":"29","rx":"3.5","stroke":"#C7C7C7"}}),_c('path',{attrs:{"d":"M15.686 12.19c0-.413-.314-.619-.68-.619-.367 0-.691.206-.691.618 0 .432.324.628.69.628.367 0 .68-.196.68-.628zm-1.246 6.238h1.12V13.72h-1.12v4.708z","fill":"#4B62C1"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M15 23a8 8 0 100-16 8 8 0 000 16z","stroke":"#4B62C1"}})])
          )
        }
      }
    